var _polygon, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCraObsLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.05 14.46 12 19.41 16.95 14.46 15.54 13.05 13 15.59 13 8 11 8 11 15.59 8.46 13.05 7.05 14.46"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 4,
    width: 2,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4,
    width: 2,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 2,
    height: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraObsLow);
export default __webpack_public_path__ + "static/media/cra-obs-low.0f4e2d21a6da60c3834c5c2419f7adb9.svg";
export { ForwardRef as ReactComponent };